import { callApi } from 'utils/api';

export function feedbackCreate(subject, text) {
  return callApi('/more/feedback', {
    method: 'POST',
    body: {
      subject,
      text
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/api.js
 **/